import React from 'react';
import PersonOutline from '@tamagoshi/core/cjs/iconsSystem/PersonOutline';
import PropTypes from 'prop-types';

const AccountB2B = ({ size }) => <PersonOutline height={size} width={size} />;

AccountB2B.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

AccountB2B.defaultProps = {
  size: 24,
};

export default AccountB2B;
